<template>
  <div class="animated fadeIn">
    <!--- Card Start --><!-- {{assign_brand_list}} -->
    <div
      v-for="brand_list in assign_brand_list"
      class="col-md-12 "
      style="float: left;margin-bottom: 15px;margin-top: 10px;"
    >
      <b-card-group deck>
        <b-card class="design_card" header-tag="header">
          <template v-slot:header>
            <div class="col-md-12">
              <h6 class="mb-0">
                <a class="font-weight-bold">
                  {{ brand_list.brand_title }}
                </a>

                <b-button
                  v-if="user_type == 'Brand_Manager'"
                  @click="openSegmentModal(brand_list.brand_id)"
                  style="line-height:1px"
                  type="button"
                  variant="primary"
                  class=" pull-right "
                  ><i
                    title="Create Segment"
                    class="fa fa-plus icons  po font-weight-bold"
                    >&nbsp; Create Segment</i
                  ></b-button
                >
              </h6>
            </div>
          </template>

          <b-card-text style="/*min-height:250px;*/">
            <!-- {{brand_list.segment_list}} -->
            <div
              style="margin-top:20px;"
              class="col-md-12"
              v-if="brand_list.segment_list.length > 0"
            >
              <b-tabs>
                <!-- {{brand_list.brand_id}} -->
                <!-- v-for="segment_list in brand_list.segments" :title="segment_list.segment_title" -->

                <b-tab
                  v-for="segment_list in brand_list.segment_list"
                  :title="segment_list.segment_title"
                  @click="
                    showCollection(brand_list.brand_id, segment_list.segment_id)
                  ">
                  <span><strong>Assign Fit Tech Name&nbsp;:</strong>&nbsp;{{
                      segment_list.fit_tech_name
                    }}</span
                  >

                  <b-button
                    @click="changesegmentModal(segment_list.segment_id)"
                    style="background: none; border:none;"
                    data-toggle="tooltip"
                    data-placement="right"
                    title="Edit Segment"
                    v-if="user_type != 'Brand_Designer'"
                    ><i
                      class="fa fa-pencil"
                      aria-hidden="true"
                      tooltip
                      style="color: blue;"
                    ></i
                    >&nbsp;</b-button
                  >
                  <!-- {{segment_list}} -->
                  <!-- <b-button @click="showCollection(brand_list.brand_id,brand_list.segment_list,brand_list.user_id)" type="button" variant="primary"> <i  title='Create Segment' class="fa fa-plus icons  po font-weight-bold">&nbsp; {{brand_list.brand_title}}</i></b-button> -->
                  <!-- code for table -->
                  <!-- {{segment_list}} -->
                  <div class="col-md-12" style="margin-top:12px;" >
                    <div class="col-md-12 pull-left" style="margin-bottom:10px">
                      <div class="row pull-left">
                        <b v-if = 'collectionData.length > 0'> Collections </b>
                      </div>

                      <div
                        class="row pull-right"
                        v-if="user_type == 'Brand_Manager'"
                      >
                        <b-button
                          @click="
                            openCollectionModal(
                              brand_list.brand_id,
                              segment_list.segment_id,
                              segment_list.segment_title
                            )
                          "
                          style="line-height:1px"
                          type="button"
                          variant="secondary"
                          class=" pull-right "
                        >
                          <i
                            title="Create Collection"
                            class="fa fa-plus icons  po font-weight-bold"
                            >&nbsp; Create Collection</i
                          >
                        </b-button>
                      </div>
                    </div>
                    <table
                      role="table"
                      aria-busy="false"
                      aria-colcount="4"
                      class="table b-table table-bordered b-table-stacked-md"
                      id="__BVID__26"
                      aria-describedby="__BVID__26__caption_"
                      v-if = 'collectionData.length > 0'>
                      <!----><!---->
                      <thead role="rowgroup" class="">
                        <!---->
                        <tr role="row">
                          <th
                            role="columnheader"
                            scope="col"
                            aria-colindex="1"
                            class=""
                          >
                            Sr No
                          </th>
                          <th
                            role="columnheader"
                            scope="col"
                            aria-colindex="2"
                            class=""
                          >
                            Collection Title
                          </th>

                          <th
                            role="columnheader"
                            scope="col"
                            aria-colindex="3"
                            class=""
                          >
                            Category
                          </th>
                          <th
                            role="columnheader"
                            scope="col"
                            aria-colindex="3"
                            class=""
                          >
                            Created Date
                          </th>
                          <th
                            role="columnheader"
                            scope="col"
                            aria-colindex="4"
                            class=""
                          >
                            Action
                          </th>
                        </tr>
                      </thead>
                      <!---->
                      <!-- this.collection_brand_id=brand_id;
                      this.collection_segment_id=segment_id; -->
     

                      <tbody
                        role="rowgroup"
                        class=""
                        v-if="collection_response == 'Successful'"
                       >
                        <!----><!--  -->
                        <tr
                          role="row"
                          class=""
                          v-for="collections_list in collectionData"
                        >
                          <td
                            role="cell"
                            aria-colindex="1"
                            data-label="DESIGN"
                            class=""
                          >
                            <div>{{ collections_list.collection_id }}</div>
                          </td>

                          <td
                            role="cell"
                            aria-colindex="1"
                            data-label="DESIGN"
                            class=""
                          >
                            <div>{{ collections_list.collection_title }}</div>
                          </td>

                          <td
                            role="cell"
                            aria-colindex="2"
                            data-label="REQUESTED SAMPLE"
                            class=""
                          >
                            <div>{{ collections_list.category_title }}</div>
                          </td>
                          <td
                            role="cell"
                            aria-colindex="4"
                            data-label="STATUS"
                            class=""
                          >
                            <div>{{ collections_list.created_date }}</div>
                          </td>
                          <td
                            role="cell"
                            aria-colindex="4"
                            data-label="STATUS"
                            class=""
                          >
                            <div>
                              <!--  <i title="Edit Collection" class="fa fa-pencil icons  pointer" @click="changecollection(collections_list.collection_id)"></i> | 
                                    <i title="View" class="fa fa-eye icons pointer"></i> | -->

                              <!-- <router-link :to="{ name: '/designs_list', params: { id: collections_list.collection_id } }"><i title="Designs" class="fa fa-picture-o icons pointer"></i></router-link>&nbsp;| -->
                              &nbsp;
                              <!-- <router-link :to="{ name: 'style_collection_new', params: { id: collections_list.collection_id } }"><i title="Styles" class="fa fa-picture-o icons pointer" style="color: #1E90FF"></i></router-link>&nbsp;   |&nbsp; -->
                              <router-link
                                :to="{
                                  name: 'style_collection_new_updated',
                                  params: {
                                    id: collections_list.collection_id,
                                    user_id: user_id,
                                    cat_id: collections_list.category_id,
                                    brand_id: brand_id
                                  },
                                }"
                                ><i
                                  title="Styles"
                                  class="fa fa-picture-o icons pointer"
                                  style="color: #1E90FF"
                                ></i
                              ></router-link>
                            </div>
                          </td>
                        </tr>
                        <!----><!---->
                      </tbody>
                      <tbody
                        role="rowgroup"
                        class=""
                        v-if="collection_response == 'Unsuccessful'"
                      >
                        <tr>
                          <td colspan="5" style="text-align: center;">
                            No Records Found
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <br /><br />
                    <table  role="table"
                    aria-busy="false"
                    aria-colcount="4"
                    class="table b-table table-bordered b-table-stacked-md"
                    id="__BVID__26"
                    aria-describedby="__BVID__26__caption_" v-if = "collectionData.length == 0">
                    No Data Found!                     
                    </table>
                  </div>

                  <!-- code for table ends -->
                  <!-- v-if="!segment_list.collections" -->
                  <!--  <div class="col-md-12" style="margin-top:12px;"v-if="collectionData===''" >
                        <tr role="row"><td>
                       No Collection Created
                       </td></tr>
                      </div> --> </b-tab
                ><br /><br />
              </b-tabs>
            </div>
            <div
              style="margin:40px;"
              class="col-md-6 pull-right"
              v-if="brand_list.segment_list.length == 0"
            >
              <label style="text-align: center;">No Segment Created</label>
            </div>
          </b-card-text>

          <!-- v-if="brand_list.segments.length <=0"  -->

          <b-card-text style="min-height:250px;" v-if="brand_list.length <= 0">
            <div style="width:100%;float:left">
              <div style="margin-top:30%;text-align:center">
                <b-button
                  title="Add New Design"
                  @click="openDesignModal(brand_list.brand_id)"
                  variant="primary"
                  aria-pressed="true"
                  class="fa fa-plus-circle fa-5x"
                >
                  Add Sub Collection</b-button
                >
              </div>
            </div>
          </b-card-text>

          <template v-slot:footer>
            <span class="mb-0"
              >{{ brand_list.length }} Collection(s)
              <!--<b-col class='col-md-1' style="float:right;text-align:right">
                    <span @click="openDesignModal(brand_list.brand_id)"> 
                      <i title='Add New Design' class=" pointer fa fa-plus icons font-1xl d-block "></i>
                    </span>
                  </b-col>-->
            </span>
          </template>
        </b-card>
      </b-card-group>
    </div>
    <!--- Card End -->

    <!-- Add Collection Model -->
    <b-modal
      title="New Collection"
      v-model="addCollection"
      @ok="addCollection = false"
    >
      <b-row>
        <b-col class="col-md-12">
          <b-form
            name="collectionform"
            @submit.prevent="collectionForm('collectionform')"
          >
            <b-col md="12">
              <div class="row">
                <label for="name">Collection Title</label>
                <!-- <b-form-input type="text" id="collection_title" name="collection_title" v-model="collection_title"   placeholder="Please enter your title."></b-form-input> -->
                <!-- 
                <b-form-select id="collection_title" name="collection_title" placeholder="Please enter your title."
                    :plain="true"
                    v-model="collection_title"
                    :options="collection_type">
                </b-form-select> -->

                <select
                  class="form-control"
                  v-model="collection_title"
                  id="collection_title"
                  name="collection_title"
                  v-validate="'required|'"
                >
                  <option value="0">-- Select Collection Title --</option>
                  <option
                    v-for="collection in collection_type"
                    :value="collection.title"
                  >
                    {{ collection.title }}
                  </option>
                </select>
              </div>
              <br />

              <div class="row">
                <label for="name">Select Category</label>
                <select
                  class="form-control"
                  v-model="collection_category"
                  id="Category_title"
                  name="Category_title"
                  v-validate="'required|'"
                >
                  <!-- <option value=0>-- Select Category Title --</option> -->
                  <option v-for="cat in categoryoptions" :value="cat.value">
                    {{ cat.text }}
                  </option>
                </select>
                <!-- <b-form-select id="month1" 
                      :plain="true"
                      v-model="collection_category"
                      :options="categoryoptions"  >
                    </b-form-select> -->
              </div>
              <br />

              <div class="row">
                <div class="row">
                  <div style="margin-top:10px;" class="col-md-12">
                    <b>Critical Path</b>
                  </div>

                  <div class="col-md-12">
                    <table
                      role="table"
                      aria-busy="false"
                      aria-colcount="4"
                      class="table b-table table-bordered b-table-stacked-md"
                      id="__BVID__26"
                      aria-describedby="__BVID__26__caption_"
                    >
                      <thead role="rowgroup" class="">
                        <!---->
                        <tr role="row">
                          <th
                            role="columnheader"
                            scope="col"
                            aria-colindex="1"
                            class=""
                          >
                            Action
                          </th>
                          <th
                            role="columnheader"
                            scope="col"
                            aria-colindex="1"
                            class=""
                          >
                            TAT
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td role="cell" aria-colindex="2">Design Creation</td>
                          <td role="cell" aria-colindex="2">
                            <b-form-input
                              type="text"
                              id="design_creation"
                              name="design_creation"
                              v-model="design_creation"
                            ></b-form-input>
                          </td>
                        </tr>
                        <tr>
                          <td role="cell" aria-colindex="2">Upload Pic</td>
                          <td role="cell" aria-colindex="2">
                            <b-form-input
                              type="text"
                              id="upload_tech_pack"
                              name="upload_tech_pack"
                              v-model="upload_tech_pack"
                            ></b-form-input>
                          </td>
                        </tr>
                        <tr>
                          <td role="cell" aria-colindex="2">
                            Upload Tech Pack
                          </td>
                          <td role="cell" aria-colindex="2">
                            <b-form-input
                              type="text"
                              id="upload_pic"
                              name="upload_pic"
                              v-model="upload_pic"
                            ></b-form-input>
                          </td>
                        </tr>
                        <tr>
                          <td role="cell" aria-colindex="2">
                            Upload Measurement Sheet
                          </td>
                          <td role="cell" aria-colindex="2">
                            <b-form-input
                              type="text"
                              id="upload_measurement_sheet"
                              name="upload_measurement_sheet"
                              v-model="upload_measurement_sheet"
                            ></b-form-input>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </b-col>
            <div slot="footer" style="margin-top:20px">
              <b-button type="submit" variant="primary" class="px-4 pull-right"
                >Create Collection</b-button
              >
            </div>
          </b-form>
        </b-col>
      </b-row>
    </b-modal>
    <!-- Add Collection Model Ends-->

    <!-- Code For Edit Collections -->

    <b-modal
      title="Edit Collection"
      v-model="editcollection"
      @ok="editcollection = false"
    >
      <template slot="modal-header" slot-scope="{ close }">
        <h5>Edit Collection</h5>
      </template>
      <template slot="default" slot-scope="{ hide }">
        <b-form
          @submit.prevent="validateForm4('form-5')"
          data-vv-scope="form-5"
        >
          <b-form-group label="Collection Title" :label-cols="3">
            <!--  <b-form-input type="text" name="collection_title"  
                  v-model="collection_title" v-validate="'required|'" :class="{'input': true, 'text-danger': errors.has('form-5.collection_title') }"placeholder="Enter Collection Title">
                  </b-form-input> -->

            <!--  <b-form-select id="collection_title" name="collection_title" v-validate="'required|'" :class="{'input': true, 'text-danger': errors.has('form-5.collection_title') }"
                    :plain="true"
                    v-model="collection_title"
                    :options="collection_type">
                </b-form-select> -->

            <select
              class="form-control"
              v-model="title"
              name="collection_title"
              v-validate="'required|'"
              :class="{
                input: true,
                'text-danger': errors.has('form-5.collection_title'),
              }"
            >
              <option value="0">-- Select Collection Title --</option>
              <option
                v-for="collection in collection_type"
                :value="collection.title"
              >
                {{ collection.title }}
              </option>
            </select>

            <b-input-group class="mb-3">
              <span class="icon has-text-warning">
                <i
                  class="fa fa-warning"
                  v-show="errors.has('collection_title')"
                ></i>
              </span>
              <code
                v-show="errors.has('form-5.collection_title')"
                id="addmblnbrmsg"
                class="help text-danger"
                >{{ errors.first("form-5.collection_title") }}
              </code>
            </b-input-group>
          </b-form-group>

          <!-- <b-form-group
                  label="Sub Category"
                  :label-cols="3" >
                  
                  <b-form-select v-model="sub_catid" id="sub_catid" name="sub_catid" placeholder="Please Enter Sub Category.">
                        <option :value="selected"  >--Select--</option>
                        <option  :value="style_list.sub_catid" v-for="style_list in sub_cat_arr">{{ style_list.sub_cattitle }}</option>
                    </b-form-select> 
                  <b-input-group class="mb-3">
                      <span class="icon has-text-warning">
                        <i class="fa fa-warning" v-show="errors.has('sub_cattitle')" ></i>
                      </span>
                      <code v-show="errors.has('form-5.sub_cattitle')" id="addmblnbrmsg" class="help text-danger">{{ errors.first('form-5.sub_cattitle') }}
                      </code>
                      </b-input-group>
                                 
                </b-form-group>
 -->
          <hr style="background-color: #989495" />
          <h5 style="text-align: center;">Critical Path</h5>
          <b-form-group label="Design Creation" :label-cols="3">
            <b-form-input
              type="text"
              name="design_creation"
              v-model="design_creation"
              v-validate="'required'"
              :class="{
                input: true,
                'text-danger': errors.has('form-5.design_creation'),
              }"
              placeholder="Enter Design Creation"
            >
            </b-form-input>
            <b-input-group class="mb-3">
              <span class="icon has-text-warning">
                <i
                  class="fa fa-warning"
                  v-show="errors.has('design_creation')"
                ></i>
              </span>
              <code
                v-show="errors.has('form-5.design_creation')"
                id="addmblnbrmsg"
                class="help text-danger"
                >{{ errors.first("form-5.design_creation") }}
              </code>
            </b-input-group>
          </b-form-group>

          <b-form-group label="Upload Pic" :label-cols="3">
            <b-form-input
              type="text"
              name="upload_pic"
              v-model="upload_pic"
              v-validate="'required'"
              :class="{
                input: true,
                'text-danger': errors.has('form-5.upload_pic'),
              }"
              placeholder="Enter Upload Pic"
            >
            </b-form-input>
            <b-input-group class="mb-3">
              <span class="icon has-text-warning">
                <i class="fa fa-warning" v-show="errors.has('upload_pic')"></i>
              </span>
              <code
                v-show="errors.has('form-5.upload_pic')"
                id="addmblnbrmsg"
                class="help text-danger"
                >{{ errors.first("form-5.upload_pic") }}
              </code>
            </b-input-group>
          </b-form-group>

          <b-form-group label="Upload Tech Pack" :label-cols="3">
            <b-form-input
              type="text"
              name="upload_tech_pack"
              v-model="upload_tech_pack"
              v-validate="'required'"
              :class="{
                input: true,
                'text-danger': errors.has('form-5.upload_tech_pack'),
              }"
              placeholder="Enter Upload Tech Pack"
            >
            </b-form-input>
            <b-input-group class="mb-3">
              <span class="icon has-text-warning">
                <i
                  class="fa fa-warning"
                  v-show="errors.has('upload_tech_pack')"
                ></i>
              </span>
              <code
                v-show="errors.has('form-5.upload_tech_pack')"
                id="addmblnbrmsg"
                class="help text-danger"
                >{{ errors.first("form-5.upload_tech_pack") }}
              </code>
            </b-input-group>
          </b-form-group>

          <b-form-group label="Upload Measurement Sheet" :label-cols="3">
            <b-form-input
              type="text"
              name="upload_measurement_sheet"
              v-model="upload_measurement_sheet"
              v-validate="'required'"
              :class="{
                input: true,
                'text-danger': errors.has('form-5.upload_measurement_sheet'),
              }"
              placeholder="Enter Upload Measurement Sheet"
            >
            </b-form-input>
            <b-input-group class="mb-3">
              <span class="icon has-text-warning">
                <i
                  class="fa fa-warning"
                  v-show="errors.has('upload_measurement_sheet')"
                ></i>
              </span>
              <code
                v-show="errors.has('form-5.upload_measurement_sheet')"
                id="addmblnbrmsg"
                class="help text-danger"
                >{{ errors.first("form-5.upload_measurement_sheet") }}
              </code>
            </b-input-group>
          </b-form-group>

          <div slot="footer" class="text-right">
            <b-button type="submit" size="sm" class="mr-4" variant="primary">
              Update</b-button
            >
            <b-button size="sm" variant="danger" @click="editprofilecancel()"
              >cancel</b-button
            >
          </div>
        </b-form>
      </template>
      <template slot="modal-footer" slot-scope="{ hide }">
        <b-button size="sm" style="display:none">
          Cancel
        </b-button>
      </template>
    </b-modal>
    <!-- Code For Edit Collections Ends -->
    <!-- @ok="addSegment = false" -->
      <!-- @submit.prevent="addNewSegment('addSegmentForm', '1')" -->
    <!-- Add Segment -->
    <b-modal
      title="Add Segment"
      v-model="addnewsegmentModel"
      @ok="submitForm"
    >
      <b-row>
        <b-col sm="12" class="col-md-12">
          <b-form
            name="addSegmentForm"
            @submit.prevent="submitForm"
          >
            <div class="col-md-12">
              <b-form-group>
                <label for="name">Select Segment Type</label>
                <b-form-select
                  id="month1"
                  :plain="true"
                  v-model="segment_title"
                  :options="segment_type"
                >
                </b-form-select>
              </b-form-group>

              <b-form-group>
                <label for="name">Assign Fit Technician</label>

                <!-- <select class="form-control"  v-model="fittech_id">
                    <option value=0>-- Select Fit Tech --</option>
                    <option v-for="fittech in fittech_list" :value="fittech.user_id" >
                        {{ fittech.full_name }}
                    </option>

                </select>  -->
                <b-form-select
                  v-model="fittech_id"
                  id="fittech_id"
                  name="fittech_id"
                  required
                >
                  <option :value="selected">--Select--</option>
                  <option
                    :value="fittech.user_id"
                    v-for="fittech in fittech_list"
                    >{{ fittech.full_name }}</option
                  >
                </b-form-select>
                <!-- <b-form-group label="Assign Fit Technician" :label-cols="3" >
                <b-form-select v-model="fittech_id" name="role" v-validate="'required|'" :class="{'input': true, 'is-invalid': errors.has('form-5.fittech_id') }">
                <option value="">--Select Segment--</option>
                <option v-for="fittech in fittech_list" :value="fittech.user_id">{{ fittech.full_name }}
                </option>
              </b-form-select>
              <b-input-group class="mb-3">
                  <span class="icon has-text-warning">
                    <i class="fa fa-warning" v-show="errors.has('fittech_id')" ></i>
                  </span>
                  <code v-show="errors.has('form-5.fittech_id')" id="addmblnbrmsg" class="help text-danger">{{ errors.first('form-5.fittech_id') }}
                  </code>
                  </b-input-group>
            </b-form-group>  -->
              </b-form-group>
            </div>

            <div slot="footer" style="margin-top:20px;text-align:right">
              <b-button type="submit" variant="primary" class="px-4"
                >Submit</b-button
              >
            </div>
          </b-form>
        </b-col>
      </b-row>
    </b-modal>
    <!-- Add New Segment Model Ends-->

    <!-- Code for Edit Segment -->
    <b-modal
      title="Edit Profile"
      v-model="changesegment"
      @ok="changesegment = false"
    >
      <template slot="modal-header" slot-scope="{ close }">
        <h5>Edit Segement</h5>
      </template>
      <template slot="default" slot-scope="{ hide }">
        <b-form
          @submit.prevent="validateForm2('form-5')"
          data-vv-scope="form-5"
        >
          <b-form-group label="Assign Fit Technician" :label-cols="3">
            <b-form-select
              v-model="fittech_id"
              name="role"
              v-validate="'required|'"
              :class="{
                input: true,
                'is-invalid': errors.has('form-5.fittech_id'),
              }"
            >
              <option value="">--Select Segment--</option>
              <option v-for="fittech in fittech_list" :value="fittech.user_id"
                >{{ fittech.full_name }}
              </option>
            </b-form-select>
            <b-input-group class="mb-3">
              <span class="icon has-text-warning">
                <i class="fa fa-warning" v-show="errors.has('fittech_id')"></i>
              </span>
              <code
                v-show="errors.has('form-5.fittech_id')"
                id="addmblnbrmsg"
                class="help text-danger"
                >{{ errors.first("form-5.fittech_id") }}
              </code>
            </b-input-group>
          </b-form-group>

          <div slot="footer" class="text-right">
            <b-button type="submit" size="sm" class="mr-4" variant="primary">
              Update</b-button
            >
            <b-button size="sm" variant="danger" @click="editsegmentcancel()"
              >cancel</b-button
            >
          </div>
        </b-form>
      </template>
      <template slot="modal-footer" slot-scope="{ hide }">
        <b-button size="sm" style="display:none">
          Cancel
        </b-button>
      </template>
    </b-modal>
    <!-- Segment Edit Code Ends  -->

    <!-- Add Sample Model -->
    <!--   <b-modal title="New Sub Collection" v-model="addDesignModal" @ok="addCollection = false">
      <b-row style="width:100%">
    <b-form style="width:100%" name="designform" @submit.prevent="AddDesign('designform')" >
      <b-col sm="12" md="12" style="width:100%">
        <b-card show-footer>
          <b-col sm="12">
              <b-form-group>
                <label for="name">Sub Colection Title</label>
                <b-form-input type="text" id="name" v-model="Design_Name"></b-form-input>
              </b-form-group>
            <b-form-group >
                <label for="name">Select Brand</label>
                <b-form-select id="month1"
                  :plain="true"
                  
                  :options="collection_brand">
                </b-form-select>
              </b-form-group>              

              <b-form-group >
                <label for="name">Select Category</label>
                <b-form-select id="month1"
                  :plain="true"
                  v-model="collection_category"
                  :options="categoryoptions">
                </b-form-select>
              </b-form-group>
              <b-form-group >
                <label for="name">Select Sub Category</label>

                <b-form-select v-model="sub_catid" id="sub_catid" name="sub_catid" placeholder="Please Enter Sub Category.">
                        <option :value="selected"  >--Select--</option>
                        <option  :value="style_list.sub_catid" v-for="style_list in sub_cat_arr">{{ style_list.sub_cattitle }}</option>
                    </b-form-select> 
              </b-form-group>
             
            </b-col>
          <div slot="footer">
         
            <b-button type="submit" style="float:right" variant="primary"  class="px-4" block>Create Design</b-button>
          </div>
        </b-card>
         
      </b-col>
      </b-form>
    </b-row>
     </b-modal> -->
    <!-- Add Sample Model Ends-->

    <!--- Add Collection Button -->
    <!--   <div id="mybutton" style="display:none">
    
   <b-col  sm="4" md="2" xl class="mb-3 mb-xl-0">
    <b-button title="Add New Collection" @click="addCollection = true" variant="danger" aria-pressed="true" class="fa fa-plus-circle fa-5x pointer"></b-button>

  </b-col>

  </div> -->
  </div>
</template>

<style>
/*.modal-content { width: 330px !important;margin:auto !important; }  */
.modal-footer {
  display: none;
}
.feedback {
  background-color: #31b0d5;
  color: white;
  padding: 10px 20px;
  border-radius: 4px;
  border-color: #46b8da;
}

#mybutton {
  position: fixed;
  bottom: -4px;
  right: 10px;
}

.card-body {
  flex: 1 1 auto;
  padding: 1.25rem;
  padding-left: 1px;
  padding-right: 1px;
  padding-top: 0px;
}

.pointer {
  cursor: pointer;
}
</style>
<script>
import CONSTANTS from "@/utils/constants";
import auth from "@/utils/auth";
import Vue from "vue";

const axios = require("axios");

export default {
  name: "Cards",
  data: function() {
    return {
      head_title: "Brands",
      sampelAddModal: false,
      addDesignModal: false,
      addCollection: false,
      updateCollection: false,
      show: true,
      isCollapsed: true,
      assign_brand_list: [],
      //category_list:[],
      collection_title: "",
      Design_Name: "",
      Design_Id: "",

      url_path: "",
      collection_category: "",

      sub_catid: "",
      collection_Id_txt: "",
      brand_id_edit: "",
      collection_title_edit: "",
      items: [],
      collection_title1: "",
      bordered: true,
      fittech_list: [],
      subcatlist: [],
      segment_title: "",
      // categoryoptions: [
      //   { value: "6", text: "Clothes & Shoes" },
      //   { value: "21", text: "Moms & Maternity" },
      // ],
      subcategoryoptions: [
        { value: "1", text: "Accessories" },
        { value: "2", text: "bottom Wear" },
      ],

      collection_brand: [
        { value: "375", text: "Unlisted Plus" },
        { value: "621", text: "Babyhug" },
      ],

      segment_type: [
        { value: "Boy", text: "Boy" },
        { value: "Girl", text: "Girl" },
        { value: "Unisex", text: "Unisex" },
        { value: "Men", text: "Men" },
        { value: "Women", text: "Women" },
      ],

      fields: [
        "Sr No",
        "Collection Title",
        "Brand",
        "Category/Sub Category",
        "Created Date",
      ],
      items: [
        {
          DESIGN: "Kartik Tshirt",
          REQUESTED_SAMPLE: "Prototype/Fit Sample",
          FACTORY: "FC-One",
          STATUS: "Approved",
        },
        {
          DESIGN: "Tiny Pink Polka Dress",
          REQUESTED_SAMPLE: "Preproduction Sample",
          FACTORY: "FC-One",
          STATUS: "Approved",
        },
      ],
      //new added
      changesegment: false,
      editcollection: false,
      customer: "",
      collection_title: "",
      sub_cat_id: "",
      design_creation: "",
      upload_pic: "",
      upload_tech_pack: "",
      upload_measurement_sheet: "",
      fittech_id: 0,
      cat_id: "",
      cat_sub_title: "",
      collection_subcategory: "",
      addnewsegmentModel: false,
      collection_brand_id: 0,
      collection_segment_id: 0,
      collection_title_edit: "",
      collectionData: [],
      collection_brand_id: "",
      collection_segment_id: "",
      collection_user_id: "",
      collection_response: "",
      utility_id: "",
      //sub_cat:[],
      selected: "",
      sub_cat_arr: [],
      selected_collection_id: 0,
      segment_value: "",
      collection_type: [],
      title: "",
      user_type: "",
      selected_segment_id: 0,
      selected_brand_manager: 0,
      brand_id:'',
      categoryoptions:[]
      //new added ends
    };
  },
  created: function() {
    this.head_title = "Brands";

    var userData = localStorage.getItem("userData");
    if (userData) {
      var userInfo = JSON.parse(userData);

      this.user_id = userInfo[0].user_id;
      this.brand_id = userInfo[0].brand_assign;
      this.user_type = userInfo[0].user_type;
      this.brandID = userInfo[0].brand_assign;
      this.getBrandSegmentList(this.user_id);
      this.getFitTechnicianList();
      this.getcollectionlisting();
      this.getBMCategory(this.user_id,this.brandID)
    }   
  },

  methods: {
    changesegmentModal: function(value) {
      this.selected_segment_id = value;
      this.changesegment = !this.changesegment;
      this.getFitTechnicianList(value);
    },

    //Update Segment Code
    validateForm2(scope) {
      this.$validator.validateAll(scope).then((result) => {
        if (result) {
          this.updatesegment();
        }
      });
    },

    updatesegment: function() {
      document.getElementById("overlay").style.display = "block";
      var userData = localStorage.getItem("userData");
      var userInfo = JSON.parse(userData);

      const Obj = {
        fittech_id: this.fittech_id,
        user_id: userInfo[0].user_id,
        updated_by: userInfo[0].email_id,
        segment_id: this.selected_segment_id,
      };
      axios
        .post(`${CONSTANTS.API_URL}/updatesegment`, Obj)
        .then((response) => {
          document.getElementById("overlay").style.display = "none";
          this.result = response.data;
          if (this.result.returnmsg === "Successful") {
            // alert("Segment Updated Successfully", "success");
            this.$fire({
              text: "Segment Updated Successfully",
              type: "success",
              timer: 30000,
            });
            this.changesegment = !this.changesegment;
            this.customer = {};
            this.getBrandSegmentList(this.user_id);
          } else {
            this.totalRows = 0;
            this.isBusy = !this.isBusy;
          }
        })
        .catch((e) => {
          this.errors.push(e);
        });
      //}
    },

    //Update Segment Code Ends

    editsegmentcancel: function() {
      this.customer = {};
      this.changesegment = !this.changesegment;
    },

    /****** Function to  Get Collection List ********/
    getcollectionlisting: function(value) {
      axios
        .post(`${CONSTANTS.API_URL}/getDefaultCollectionTitle`, {})
        .then((response) => {
          document.getElementById("overlay").style.display = "none";
          this.result = response.data;

          if (this.result.returnmsg === "Successful") {
            this.collection_type = this.result.returnvalue;
            this.totalRows = this.result.returnvalue.length;
            //this.isBusy = !this.isBusy;
          } else {
            this.collection_type = [];
            this.totalRows = 0;
            this.isBusy = !this.isBusy;
          }
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },

    /****** Function To Get Collection List Ends ********/

    /****** Function to Get Fit Technician ********/
    getFitTechnicianList: function(value) {
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);

      this.login_user_id = userInfo[0].user_id;
      this.isBusy = true;
      const Obj = {
        brand_id: userInfo[0].brand_assign,
        segment_id: value,
      };
      axios
        .post(`${CONSTANTS.API_URL}/getFitTechnicianList`, Obj)
        .then((response) => {
          document.getElementById("overlay").style.display = "none";
          this.result = response.data;

          if (this.result.returnmsg === "Successful") {
            this.fittech_list = this.result.returnvalue;
            this.totalRows = this.result.returnvalue.length;
            this.isBusy = !this.isBusy;
          } else {
            this.fittech_list = [];
            this.totalRows = 0;
            this.isBusy = !this.isBusy;
          }
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },

    // Open Segment Model
    openSegmentModal(brand_id) {
      this.segment_title = "";
      this.fittech_id = 0;
      this.addnewsegmentModel = true;
      this.brand_id_edit = brand_id;
    },

    // Open Segment Model
    showCollection(brand_id, segment_id) {
      document.getElementById("overlay").style.display = "block";
      this.collection_brand_id = brand_id;
      this.collection_segment_id = segment_id;
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);

      this.login_user_id = userInfo[0].user_id;

      const Obj = {
        brand_id: userInfo[0].brand_assign,
        segment_id: this.collection_segment_id,
        user_id: this.login_user_id,
      };
      axios
        .post(`${CONSTANTS.API_URL}/getSegmentCollectionList`, Obj)
        .then((response) => {
          document.getElementById("overlay").style.display = "none";
          this.collection_response = response.data.returnmsg;
          console.log("~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~");

          if (response.data.returnmsg == "Successful") {
            this.collectionData = response.data.returnvalue.collections;
            // this.sub_cattitle=response.data.returnvalue.collections.sub_cattitle
          } else {
            if (response.data.returnmsg == "Unsuccessful") {
              this.collectionData = [];
              this.showAlert = true;
            }
          }
        });
    },

    /****** Function to Add Segment ********/
    submitForm() {
      if (this.segment_title == "") {
        console.log("segment type is required");
       this.$fire({
        text: "Segment type is mandatory",
        type: "warning",
        timer: 3000,
      });
    } else {
      // Proceed with form submission logic
      // Call the function to add the segment
      this.addNewSegment('addSegmentForm', '1');
    }
  },
  
    addNewSegment(scope, brand_id) {
      document.getElementById("overlay").style.display = "block";

      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      this.login_user_id = userInfo[0].user_id;
      const segmentObj = {
        segment_title: this.segment_title,
        fittech_id: this.fittech_id,
        brand_id: this.brand_id_edit,
        created_by: userInfo[0].email_id,
        user_id: this.login_user_id,
        brand_manager: userInfo[0].user_id,
      };

      if (this.segment_title !== "") {
        axios
          .post(`${CONSTANTS.API_URL}/savebrandsegmentdata`, segmentObj)
          .then((response) => {
            document.getElementById("overlay").style.display = "none";
            if (response.data.returnmsg == "Successful") {
              // alert("New Segment Added Successfully.");
              this.$fire({
                text: "New Segment Added Successfully.",
                type: "success",
                timer: 30000,
              });
              this.addnewsegmentModel = !this.addnewsegmentModel;
              this.getBrandSegmentList(this.user_id);
            } else {
              if (response.data.returnmsg === "unsuccessful") {
                this.segment_value = response.data.returnvalue;
                // alert(response.data.returnvalue);
                this.$fire({
                  text: response.data.returnvalue,
                  type: "error",
                  timer: 30000,
                });
                this.addnewsegmentModel = !this.addnewsegmentModel;
                this.showAlert = true;
              }
            }
          });
      }
    },
    // userInfo[0].brand_manager
    /****** Function to Get Brand & Segments ********/
    getBrandSegmentList: function(user_id) {
      this.isBusy = true;
      var userData = localStorage.getItem("userData");
      if (userData) {
        var userInfo = JSON.parse(userData);
        this.user_id = userInfo[0].user_id;
        this.brand_assign = userInfo[0].brand_assign;
        if (userInfo[0].user_type == "Brand_Manager") {
          this.selected_brand_manager = userInfo[0].user_id;
        } else {
          this.selected_brand_manager = userInfo[0].brand_manager;
        }
        console.log("KKKKKKKKKKKKKKKKKKKKKKKK", userInfo[0]);
        var obj = {
          user_id: this.user_id,
          selected_brand: this.brand_assign,
          brand_manager: this.selected_brand_manager,
        };
        console.log(")))))))))))))))))))))", obj);
        axios
          .post(`${CONSTANTS.API_URL}/getBrandSegmentList`, obj)
          .then((response) => {
            document.getElementById("overlay").style.display = "none";
            this.result = response.data;
            if (this.result.returnmsg === "Successful") {
              this.assign_brand_list = this.result.returnvalue;
              this.totalRows = this.assign_brand_list[0]["segment_list"].length;

              if (this.totalRows > 0) {
                var segment_id = this.assign_brand_list[0]["segment_list"][0][
                  "segment_id"
                ];
                var brand_id = this.assign_brand_list[0]["segment_list"][0][
                  "brand_id"
                ];
                this.showCollection(brand_id, segment_id);
              }
              this.isBusy = !this.isBusy;
            } else {
              this.assign_brand_list = [];
              this.totalRows = 0;
              this.isBusy = !this.isBusy;
            }
          })
          .catch((e) => {
            this.errors.push(e);
          });
      }
    },

    /****** Function to Get Category List ********/
    // Categorylist: function () {

    //     this.isBusy = true;
    //     var userdata = localStorage.getItem('userData')
    //     var userInfo = JSON.parse(userdata);

    //     axios.post(`${CONSTANTS.API_URL}/getCategoryList`,{})
    //     .then(response => {
    //       document.getElementById("overlay").style.display = "none";
    //       this.result = response.data
    //       if (this.result.returnmsg === 'Successful') {

    //         this.category_list  = this.result.returnvalue;
    //         this.totalRows = this.result.returnvalue.length;

    //         this.isBusy = !this.isBusy;

    //       }else {
    //        this.category_list =[];
    //        this.totalRows=0;
    //          this.isBusy = !this.isBusy;
    //       }

    //     })
    //     .catch(e => {
    //       this.errors.push(e)
    //     })

    // },

    /****** Function to Add Collection ********/

    openCollectionModal(brand_id, segment_id, segment_title) {
      //Comment Code For set blank param for model

      this.collection_title = "";
      this.design_creation = "";
      this.upload_pic = "";
      this.upload_tech_pack = "";
      this.upload_measurement_sheet = "";
      //Code ends
      this.addCollection = true;
      this.collection_brand_id = brand_id;
      this.collection_segment_id = segment_id;
      this.collection_segment_title = segment_title;
    },

    collectionForm(scope) {
      // alert("Innnn")
      // document.getElementById("overlay").style.display = "block";
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      this.user_id = userInfo[0].user_id;
      this.$validator.validateAll(scope).then((result) => {
        if (result) {
          const collectionObj = {
            brand_id: userInfo[0].brand_assign,
            collection_title: this.collection_title,
            cat_id: this.collection_category,
            segment_id: this.collection_segment_id,
            design_creation: this.design_creation,
            upload_pic: this.upload_pic,
            upload_tech_pack: this.upload_tech_pack,
            upload_measurement_sheet: this.upload_measurement_sheet,
            user_id: this.user_id,
            created_by: userInfo[0].email_id,
          };
          console.log("rrrrrrrrrrrrrrrrrrrrrrr", collectionObj);
          // return false;

          if (this.collection_title !== "") {
            axios
              .post(`${CONSTANTS.API_URL}/addnewcollections`, collectionObj)
              .then((response) => {
                document.getElementById("overlay").style.display = "none";
                if (response.data.returnmsg == "Successful") {
                  var segment_id = this.collection_segment_id;
                  var brand_id = this.collection_brand_id;
                  this.showCollection(
                    this.collection_brand_id,
                    this.collection_segment_id
                  );
                  // alert("New Collection Added Successfully.");
                  this.$fire({
                    text: "New Collection Added Successfully.",
                    type: "success",
                    timer: 30000,
                  });
                  this.addCollection = false;

                  // this.showCollection();
                } else if (response.data.returnmsg == "unsuccessful") {
                  // alert(response.data.returnvalue);
                  this.$fire({
                    text: response.data.returnvalue,
                    type: "error",
                    timer: 30000,
                  });
                  this.showAlert = true;
                }
              });
          } else {
            // alert("Please Enter Collection Title...");
            this.$fire({
              text: "Please Enter Collection Title...",
              type: "warning",
              timer: 30000,
            });
          }
        }
      });
    },

    openDesignModal(collection_id) {
      this.addDesignModal = true;
      this.collection_id = collection_id;
    },

    //Edit collection model
    changecollection: function(value) {
      this.selected_collection_id = value;
      this.editcollection = !this.editcollection;
    },
    //Edit collection model Ends

    editprofilecancel: function() {
      this.customer = {};
      this.editcollection = !this.editcollection;
    },

    //Update Collection Code
    updatecollection: function() {
      document.getElementById("overlay").style.display = "block";
      var userData = localStorage.getItem("userData");

      var userInfo = JSON.parse(userData);

      const Obj = {
        collection_title: this.collection_title,
        design_creation: this.design_creation,
        upload_pic: this.upload_pic,
        upload_tech_pack: this.upload_tech_pack,
        upload_measurement_sheet: this.upload_measurement_sheet,
        updated_by: userInfo[0].email_id,
        user_id: userInfo[0].user_id,
        collection_id: this.selected_collection_id,
      };
      axios
        .post(`${CONSTANTS.API_URL}/updatecollection`, Obj)
        .then((response) => {
          document.getElementById("overlay").style.display = "none";
          this.result = response.data;
          if (this.result.returnmsg === "Successful") {
            // alert("Updated Successfully", "success");
            this.$fire({
              text: "Updated Successfully.",
              type: "success",
              timer: 30000,
            });
            this.editcollection = !this.editcollection;
            this.customer = {};
            this.getBrandSegmentList(this.user_id);
          } else {
            this.totalRows = 0;
            this.isBusy = !this.isBusy;
          }
        })
        .catch((e) => {
          this.errors.push(e);
        });
      //}
    },
    //Update Collection Code Ends

    validateForm4(scope) {
      this.$validator.validateAll(scope).then((result) => {
        if (result) {
          this.updatecollection();
        }
      });
    },
   getBMCategory(user_id,brand_id){
    const Obj = {
       user_id: user_id,
       brand_id:brand_id
      };
      axios
        .post(`${CONSTANTS.API_URL}/getBMCategory`, Obj)
        .then((response) => {
          this.result = response.data;
          if (this.result.returnmsg === "Successful") {
             this.result.returnvalue.forEach(element => {
              let obj = {};
              obj.value = '';
              obj.text = '';
              obj.value = element.category_id;
              obj.text = element.category_title;
              this.categoryoptions.push(obj);
             });    
          } else if (response.data.returnmsg.toLowerCase() == "unsuccessful") {
            this.categoryoptions = [];
            this.$fire({
              text: response.data.returnvalue,
              type: "error",
              timer: 30000,
            });
          }else {
          this.categoryoptions = [];
          this.$fire({
            text: 'Error while getting Brand Manager Category!',
            type: "error",
            timer: 30000,
          });
        }
    })
   }
  }
};
</script>
